import createReactComponent from '../createReactComponent';
export default createReactComponent('align-center', 'IconAlignCenter', [
  ['path', { d: 'M4 6l16 0', key: 'svg-0' }],
  ['path', { d: 'M8 12l8 0', key: 'svg-1' }],
  ['path', { d: 'M6 18l12 0', key: 'svg-2' }],
]);
